import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';
import { useState, useEffect, useMemo, useCallback } from 'react';
import { getInfiniteHitsCache } from '../helpers/cache';
const cache = getInfiniteHitsCache();
const useHeadlessResults = function () {
  let loadAllPages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const {
    hits: infiniteHits,
    currentPageHits,
    isLastPage,
    showMore
  } = useInfiniteHits({
    cache
  });
  const {
    indexUiState: {
      configure
    }
  } = useInstantSearch();
  const [allPagesLoaded, setAllPagesLoaded] = useState(false);
  const [searchQuery, searchFilters] = useMemo(() => {
    const parameters = configure;
    return [parameters?.query || '', parameters?.filters || ''];
  }, [configure]);
  const loadNextPage = useCallback(() => {
    // Wait for the showMore function to be defined
    // and the first page of hits to have been loaded
    // before checking if we have to load more.
    if (!showMore || !infiniteHits.length) {
      return;
    }

    // If we're on the last page, stop loading more.
    if (isLastPage) {
      setAllPagesLoaded(true);
      return;
    }

    // Load the next page.
    showMore();
  }, [infiniteHits.length, isLastPage, showMore]);
  useEffect(() => {
    // Don't continue if we don't want to load all pages or
    // if we're done loading them all.
    if (!loadAllPages || allPagesLoaded) {
      return;
    }
    loadNextPage();
  }, [loadAllPages, allPagesLoaded, loadNextPage]);
  useEffect(() => {
    // If search query or filters change, invalidate the cache
    // and reset allPagesLoaded. This retriggers the other useEffect
    // to start loading all the pages again with the new state.
    cache.invalidate();
    setAllPagesLoaded(false);
  }, [searchQuery, searchFilters]);
  return {
    infiniteHits,
    currentPageHits,
    allPagesLoaded,
    loadNextPage
  };
};
export default useHeadlessResults;